import { TemplateRef } from '@angular/core';
import { Validators } from '@angular/forms';
import { Custom, Option, Tarea, TareaRol } from '@app/shared';
import { BaseControl, TextArea, Textbox } from '@app/shared/dynamic-form';
import { isEmpty } from 'lodash';

export interface ConfigFields extends Tarea {
  statusOptions: Option[];
  typesOptions: Option[];
  selectRolesTpl: TemplateRef<any>;
  asignationRoles: TareaRol[];
  responsibleRoles: TareaRol[];
}

export class FormService {
  constructor() { }

  getFields(obj: Partial<ConfigFields>): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: 'nombre',
        type: 'text',
        label: 'Nombre:',
        placeholder: 'Nombre predeterminado de la tarea',
        value: !isEmpty(obj.nombre) ? obj.nombre : null,
        order: 1,
        validations: {
          validators: [Validators.required, Validators.maxLength(255)]
        },
        disabled: true
      }),

      new TextArea({
        key: 'descripcion',
        label: 'Descripción:',
        placeholder: 'Descripción predeterminada de la tarea',
        rows: '2',
        value: !isEmpty(obj.descripcion) ? obj.descripcion : null,
        order: 2,
        validations: {
          validators: [Validators.required, Validators.minLength(5)]
        },
        disabled: true
      }),
      new Custom({
        key: 'asignationRoles',
        label: 'Roles para las asignaciones:',
        order: 4,
        value: !isEmpty(obj.asignationRoles) ? obj.asignationRoles : [],
        template: obj.selectRolesTpl,
        placeholder: 'Roles que pueden asignar esta tarea.',
        validations: {
          validators: [Validators.required]
        },
      }),

      new Custom({
        key: 'responsibleRoles',
        label: 'Roles responsables:',
        order: 5,
        value: !isEmpty(obj.responsibleRoles) ? obj.responsibleRoles : [],
        template: obj.selectRolesTpl,
        placeholder: 'Roles que pueden ejecutar esta tarea.',
        validations: {
          validators: [Validators.required]
        },
      }),

      new Textbox({
        key: 'rechazable',
        type: 'checkbox',
        label: 'Rechazable',
        class: {
          container: ['form-check', 'form-check-inline']
        },
        value: obj.hasOwnProperty('rechazable') ? obj.rechazable : false,
        order: 7
      })
    ];
    return controls;
  }
}



// WEBPACK FOOTER //
// ./src/app/flow/task/shared/form-service.ts